var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/* eslint-disable @rushstack/security/no-unsafe-regexp */
/* eslint-disable no-constant-condition */
import React, { useContext, useEffect, useState } from 'react';
import { Text, Link, ChatMessage, Avatar, Flex } from 'pcln-design-system';
import { format } from 'date-fns';
import { ChatbotDataContext } from './context/ChatbotDataContext';
import { livePersonMessagesStatusManager } from './LivePersonService/livePersonMessageStatusManager';
import { TravelBotLogoImage } from './TravelBotLogoImage';
var COSTUMER_SUPPORT_NUMBER = '1-877-477-5807';
var pricelineHyperLinkRegExpPattern = /http(s)?:\/\/(www\.)?priceline\.com((\/(\w|-)+)+?)+(\/)?(\?)?(((\w)+\=(\w)+&?)?)+/;
var phoneNumberRegexPattern = /(\d-)?\d{3}-\d{3}-\d{4}/;
var boldTextRegexPattern = /\*\*(\w|\W)+\*\*/;
var regExpPatternList = [
    {
        type: 'phoneNumber',
        pattern: phoneNumberRegexPattern,
    },
    {
        type: 'hyperlink',
        pattern: pricelineHyperLinkRegExpPattern,
    },
    {
        type: 'boldText',
        pattern: boldTextRegexPattern,
    },
];
var setHyperlinkFormatInContent = function (_a) {
    var content = _a.content, regexPatternIndex = _a.regexPatternIndex;
    if (!content) {
        return [];
    }
    try {
        var _b = regExpPatternList[regexPatternIndex], type = _b.type, pattern = _b.pattern;
        var newRegExp = new RegExp(pattern, 'g');
        var previousMatchedIndex = 0;
        var finalList = [];
        while (true) {
            var result = newRegExp.exec(content);
            if (result) {
                var matchedContent = result[0];
                var index = result.index;
                var preFix = content
                    .slice(previousMatchedIndex, index + matchedContent.length)
                    .replaceAll(matchedContent, '');
                previousMatchedIndex = index + matchedContent.length;
                if (regexPatternIndex + 1 < regExpPatternList.length) {
                    var nextFormatedList = setHyperlinkFormatInContent({
                        content: preFix,
                        regexPatternIndex: regexPatternIndex + 1,
                    });
                    finalList.push.apply(finalList, __spreadArray(__spreadArray([], nextFormatedList, false), [{
                            preFix: nextFormatedList.length === 0 ? preFix : '',
                            matchedContent: matchedContent,
                            type: type,
                        }], false));
                }
                else {
                    finalList.push({
                        preFix: preFix,
                        matchedContent: matchedContent,
                        type: type,
                    });
                }
            }
            else {
                var preFix = content.slice(previousMatchedIndex);
                if (regexPatternIndex + 1 < regExpPatternList.length) {
                    var nextFormatedList = setHyperlinkFormatInContent({
                        content: preFix,
                        regexPatternIndex: regexPatternIndex + 1,
                    });
                    finalList.push.apply(finalList, nextFormatedList);
                }
                else if (preFix) {
                    finalList.push({
                        preFix: preFix,
                        matchedContent: '',
                        type: '',
                    });
                }
                break;
            }
        }
        return finalList;
    }
    catch (_) {
        return [];
    }
};
/**
 * TravelBotChatSingleDialogGeneric
 * Support showing message content for assistan/user
 * @public
 */
export var TravelBotChatSingleDialogGeneric = function (props) {
    var _a;
    var _b = useContext(ChatbotDataContext), logCustomerCarePhoneNumberClicked = _b.logCustomerCarePhoneNumberClicked, logCustomerCarePhoneNumberDisplayed = _b.logCustomerCarePhoneNumberDisplayed;
    var message = props.message, livePersonAgentInitial = props.livePersonAgentInitial, livePersonAgentName = props.livePersonAgentName;
    var content = message.content, role = message.role;
    var isAssistant = role === 'assistant';
    var isLivePersonAgent = role === 'livePersonAgent';
    var isNotUser = isAssistant || isLivePersonAgent;
    var _c = useState([]), linesOfContents = _c[0], pushOneLineContent = _c[1];
    function phoneNumberClicked() {
        if (logCustomerCarePhoneNumberClicked && typeof logCustomerCarePhoneNumberClicked === 'function') {
            logCustomerCarePhoneNumberClicked();
        }
    }
    useEffect(function () {
        var _a, _b;
        var finalLinesOfContents = [];
        var bulletPointStartsIndex = -1;
        if (isNotUser) {
            (_b = (_a = content
                .split('\n')) === null || _a === void 0 ? void 0 : _a.filter(function (c) { return !!c; })) === null || _b === void 0 ? void 0 : _b.forEach(function (sc, i) {
                var hasBulletPointStarter = sc.startsWith('-');
                if (hasBulletPointStarter && bulletPointStartsIndex === -1) {
                    bulletPointStartsIndex = i;
                }
                var hasBulletPoint = bulletPointStartsIndex !== -1;
                var rawLineContent = hasBulletPoint && hasBulletPointStarter
                    ? sc.replace('-', "".concat(i + 1 - bulletPointStartsIndex, "."))
                    : sc;
                var oneLineContent = setHyperlinkFormatInContent({
                    content: rawLineContent,
                    regexPatternIndex: 0,
                });
                if (oneLineContent.length !== 0) {
                    finalLinesOfContents.push(oneLineContent);
                }
            });
            pushOneLineContent(finalLinesOfContents);
        }
        else {
            pushOneLineContent([
                [
                    {
                        preFix: content,
                        matchedContent: '',
                        type: '',
                    },
                ],
            ]);
        }
    }, [content]);
    var MessageIcon = function Icon(props) {
        if (isAssistant) {
            return (React.createElement(TravelBotLogoImage, null));
        }
        if (isLivePersonAgent) {
            return React.createElement(Avatar, __assign({}, props, { initials: livePersonAgentInitial, color: 'primary' }));
        }
        return null;
    };
    var footerMessagePrefix = isAssistant
        ? 'Penny'
        : isLivePersonAgent
            ? livePersonAgentName
                ? ((_a = livePersonAgentName === null || livePersonAgentName === void 0 ? void 0 : livePersonAgentName.split(' ')) === null || _a === void 0 ? void 0 : _a[0]) || livePersonAgentInitial
                : 'Agent'
            : '';
    var footerMessageDateString = (message === null || message === void 0 ? void 0 : message.date) ? format(message === null || message === void 0 ? void 0 : message.date, "LLL d 'at' h:mm:ss aaa") : '';
    var messgeStatus = livePersonMessagesStatusManager.getStatusByMsgId(message.msgId);
    var Footer = footerMessageDateString ? (React.createElement(Flex, { alignItems: 'center', justifyContent: isNotUser ? 'space-between' : 'flex-end' },
        messgeStatus && (React.createElement(Text, { color: 'text.light', textStyle: 'subheading6', mr: 2 }, messgeStatus)),
        footerMessagePrefix && (React.createElement(Text, { color: 'text.light', textStyle: 'subheading6' },
            footerMessagePrefix,
            " \u00B7 ",
            footerMessageDateString)),
        !footerMessagePrefix && (React.createElement(Text, { color: 'text.light', textStyle: 'subheading6' }, footerMessageDateString)))) : null;
    return (React.createElement(ChatMessage, { mb: isNotUser ? '40px' : 4, ml: isNotUser ? '' : 'auto', variation: isNotUser ? 'initial' : 'outgoing', Icon: MessageIcon, message: React.createElement(Text, { fontSize: 2 }, linesOfContents.map(function (oneLine, lIndex) {
            oneLine.map(function (cont) {
                if (cont.type === 'phoneNumber' &&
                    cont.matchedContent === COSTUMER_SUPPORT_NUMBER &&
                    logCustomerCarePhoneNumberDisplayed &&
                    typeof logCustomerCarePhoneNumberDisplayed === 'function') {
                    logCustomerCarePhoneNumberDisplayed();
                }
            });
            var isLastLine = lIndex === linesOfContents.length - 1;
            return (React.createElement(Text, { fontSize: 2, key: "chat-content-line-".concat(lIndex), mb: isLastLine ? 0 : 2 }, oneLine.map(function (cont, cIndex) {
                return (React.createElement(React.Fragment, { key: "cont-".concat(cIndex) },
                    cont.preFix,
                    cont.type === 'phoneNumber' && (React.createElement(Link, { href: "tel:".concat(cont.matchedContent.replace(/\D/g, '')), onClick: cont.matchedContent === COSTUMER_SUPPORT_NUMBER ? phoneNumberClicked : undefined }, cont.matchedContent)),
                    cont.type === 'hyperlink' && (React.createElement(Link, { href: cont.matchedContent, title: "hyper link for ".concat(cont.matchedContent), target: '_blank' }, cont.matchedContent)),
                    cont.type === 'boldText' && (React.createElement(Text.span, { bold: true }, cont.matchedContent.replace(/\*/g, '')))));
            })));
        })), footer: Footer }));
};
//# sourceMappingURL=TravelBotChatSingleDialogGeneric.js.map